import { render, staticRenderFns } from "./ClassEvaluationAndAttendance.vue?vue&type=template&id=f4f2cc2a&scoped=true&"
import script from "./ClassEvaluationAndAttendance.vue?vue&type=script&lang=js&"
export * from "./ClassEvaluationAndAttendance.vue?vue&type=script&lang=js&"
import style0 from "./ClassEvaluationAndAttendance.vue?vue&type=style&index=0&id=f4f2cc2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f2cc2a",
  null
  
)

export default component.exports